import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { ProjectEmployeeDedicationRepository } from "@project/data/repositories/project-employee-dedication.repository";
import { InvalidDedicationDatesError } from "@project/domain/errors/invalid-dedication-dates.error";
import {
    ProjectEmployeeDedication,
    UpdateProjectEmployeeDedication,
} from "@project/domain/models/project-employee-dedications.model";
import { inject, injectable } from "inversify";

@injectable()
export class UpdateProjectEmployeeDedicationUsecase {
    constructor(
        @inject(ProjectEmployeeDedicationRepository)
        private readonly projectEmployeeDedicationRepository: ProjectEmployeeDedicationRepository,
    ) {}

    async execute(
        updateProjectEmployeDedications: UpdateProjectEmployeeDedication,
    ): Promise<Nullable<ProjectEmployeeDedication>> {
        const projectEmployeeDedicationResult =
            await this.projectEmployeeDedicationRepository.update(
                updateProjectEmployeDedications,
            );

        return projectEmployeeDedicationResult.fold(
            (error) => {
                if (error instanceof InvalidDedicationDatesError) {
                    ToastManagerStore.warning(error.message);
                } else {
                    ToastManagerStore.error(error.message);
                }

                return null;
            },
            (projectEmployeeDedication) => projectEmployeeDedication,
        );
    }
}
